$(window).scroll(function () {
    var navBarNav = $('header .navbar-nav'),
        contentContainer = $('.containerWrapper'),
        navHeight = parseInt(navBarNav.outerHeight()),
        currentYPos = $(this).scrollTop();

    if (currentYPos <= 120) {
        if (navHeight < 120) {
            contentContainer.removeClass("navPosMiddle").removeClass("navPosBottom").addClass("navPosTop");
        }
    } else if (currentYPos > 120 && currentYPos <= 470) {
        contentContainer.removeClass("navPosTop").removeClass("navPosBottom").addClass("navPosMiddle");
    } else if (currentYPos > 471) {
        contentContainer.removeClass("navPosTop").removeClass("navPosMiddle").addClass("navPosBottom");
    }
});